import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { query, property, state } from 'lit/decorators.js';
import { addStyleSheetToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/cssstylesheet-interface.js';
import { gridBreakpoints } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/breakpoints.js';
import { InternalI18n } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/i18n/internal-i18n-controller.js';
import { debounce } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/debounce.js';
import '@cigna/cigna_csg_gsg_cipublic-icon/cipublic-icon.js';
import '@cigna/cigna_csg_gsg_cipublic-close-button/cipublic-close-button.js';
import '@cigna/cigna_csg_gsg_cipublic-link/cipublic-link.js';
import '@cigna/cigna_csg_gsg_cipublic-focus-trap/cipublic-focus-trap.js';
import '@cigna/cigna_csg_gsg_cipublic-search/cipublic-search.js';
import styles from './header-search.scss.js';
import searchButtonStyles from './search-button.scss.js';
export class HeaderSearch extends CipublicElement {
    constructor() {
        super(...arguments);
        this.action = '/search';
        this.i18n = new InternalI18n(this);
    }
    get isMobile() {
        return !window.matchMedia(`(min-width: ${gridBreakpoints.lg}px)`).matches;
    }
    async firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        addStyleSheetToElements([this.link], searchButtonStyles);
        await this.updateComplete;
        this.windowWidth = window.innerWidth;
        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', 'true');
        window.addEventListener('resize', debounce(() => {
            if (this.windowWidth !== window.innerWidth) {
                this.windowWidth = window.innerWidth;
                this.closeSearch();
            }
        }, 100));
    }
    openSearch() {
        var _a, _b, _c, _d;
        this.cipublicSearch.removeAttribute('hidden');
        this.closeSearchButton.removeAttribute('hidden');
        this.classList.add('search-active');
        this.searchContainer.removeAttribute('aria-hidden');
        this.searchContainer.setAttribute('trapped', '');
        (_b = (_a = this.cipublicSearch) === null || _a === void 0 ? void 0 : _a.cipublicInput) === null || _b === void 0 ? void 0 : _b._input.removeAttribute('aria-describedby');
        (_d = (_c = this.cipublicSearch) === null || _c === void 0 ? void 0 : _c.cipublicInput) === null || _d === void 0 ? void 0 : _d._input.focus();
        this.dispatchEvent(new CustomEvent('search-opened', { bubbles: true, composed: true }));
    }
    closeSearch() {
        var _a, _b, _c, _d;
        this.classList.remove('search-active');
        this.cipublicSearch.setAttribute('hidden', '');
        this.closeSearchButton.setAttribute('hidden', '');
        this.searchContainer.setAttribute('aria-hidden', 'true');
        this.dispatchEvent(new CustomEvent('search-closed', { bubbles: true, composed: true }));
        if (this.isMobile)
            (_b = (_a = this.cipublicSearch) === null || _a === void 0 ? void 0 : _a.cipublicInput) === null || _b === void 0 ? void 0 : _b.setAttribute('labelvisuallyhidden', '');
        else
            (_d = (_c = this.cipublicSearch) === null || _c === void 0 ? void 0 : _c.cipublicInput) === null || _d === void 0 ? void 0 : _d.removeAttribute('labelvisuallyhidden');
    }
    static get styles() {
        return [styles];
    }
    render() {
        return html `<cipublic-link href="#" isbutton="" class="search-open-button" @click="${this.openSearch}">${this.i18n.t('search')}<cipublic-icon slot="suffix" set="system" name="search" class="search-icon"></cipublic-icon></cipublic-link><cipublic-focus-trap class="search-content-wrapper" aria-hidden="true"><cipublic-search action="${this.action}" ?inline="${true}" hidden></cipublic-search><cipublic-close-button hidden class="dismiss search-close-button" @click="${() => {
            var _a, _b;
            this.closeSearch();
            (_b = (_a = this.openSearchButton.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('button')) === null || _b === void 0 ? void 0 : _b.focus();
        }}"></cipublic-close-button></cipublic-focus-trap>`;
    }
}
__decorate([
    property()
], HeaderSearch.prototype, "action", void 0);
__decorate([
    query('.search-open-button')
], HeaderSearch.prototype, "openSearchButton", void 0);
__decorate([
    query('.search-close-button')
], HeaderSearch.prototype, "closeSearchButton", void 0);
__decorate([
    query('.search-content-wrapper')
], HeaderSearch.prototype, "searchContainer", void 0);
__decorate([
    query('cipublic-search')
], HeaderSearch.prototype, "cipublicSearch", void 0);
__decorate([
    state()
], HeaderSearch.prototype, "isMobile", null);
__decorate([
    state()
], HeaderSearch.prototype, "windowWidth", void 0);
__decorate([
    query('cipublic-link')
], HeaderSearch.prototype, "link", void 0);
//# sourceMappingURL=header-search.js.map